import { Head } from "vite-react-ssg";
import { Link } from "react-router-dom";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { sortedArticles } from "@/content/blog";

const fmtDate = (iso: string) =>
  new Date(iso + "T00:00:00").toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

const Blog = () => (
  <div className="min-h-screen" style={{ background: "#ffffff" }}>
    <Head>
      <title>Blog — CoachOS · conseils pour coachs sportifs indépendants</title>
      <meta name="description" content="Guides concrets pour coachs sportifs indépendants : gestion clients, programmes, rétention, nutrition et outils. Par l'équipe CoachOS." />
      <link rel="canonical" href="https://www.coach-os.eu/blog" />
    </Head>
    <Navbar />
    <main className="container max-w-4xl pt-32 pb-24">
      <p className="mb-3 text-sm font-semibold uppercase tracking-wider text-[#3730A3]">Blog</p>
      <h1 className="text-3xl md:text-5xl font-extrabold tracking-tighter text-[#0e1220] mb-3">
        Le métier de coach, <span className="text-[#3730A3]">côté pratique.</span>
      </h1>
      <p className="max-w-xl text-[#0e1220]/55 mb-14">
        Guides concrets sur la gestion de clients, les programmes et la rétention — sans blabla.
      </p>

      <div className="divide-y divide-[#e7e9f1]">
        {sortedArticles().map((a) => (
          <Link
            key={a.slug}
            to={`/blog/${a.slug}`}
            className="group grid gap-2 py-8 md:grid-cols-[140px_1fr] md:gap-8"
          >
            <div className="text-sm text-[#0e1220]/40">
              {fmtDate(a.date)}
              <span className="block mt-1">{a.readingMinutes} min</span>
            </div>
            <div>
              <h2 className="text-xl font-bold text-[#0e1220] transition-colors group-hover:text-[#3730A3]">
                {a.title}
              </h2>
              <p className="mt-2 text-[#0e1220]/55 leading-relaxed">{a.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </main>
    <Footer />
  </div>
);

export default Blog;
